import React from 'react';
import logo from '../../Assets/images/logo.png';
import './logo.css';

const Logo = () => {
	return (
		<div>
			<img id = "Logo" src={logo} alt='claudiu-logo' />
		</div>
		)
}

export default Logo;